export interface PatientSyncType {
  id: number;
  lastSyncState: Date;
  syncServiceType: SyncServiceType;
  syncState: SyncState;
}

export enum SyncState {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  FINISHED = "FINISHED",
  ERROR = "ERROR",
}

export enum SyncServiceType {
  DEFAULT = "DEFAULT",
  VITALINK = "VITALINK",
  INSURABILITY = "INSURABILITY",
  GMD = "GMD",
  VITALINK_MEDICATION = "VITALINK_MEDICATION",
  VITALINK_VACCINATION = "VITALINK_VACCINATION",
  HELENA_MEDICATION = "HELENA_MEDICATION",
  HELENA_VACCINATION = "HELENA_VACCINATION",
  CONSULT_RN = "CONSULT_RN",
  HELENA_INVITATION = "HELENA_INVITATION",
  CONSULT_RN_ID_SUPPORT = "CONSULT_RN_ID_SUPPORT",
  CONSULT_RN_PERSON_SERVICE = "CONSULT_RN_PERSON_SERVICE",
  CONSULT_RN_BCSS_PERSON_SERVICE = "CONSULT_RN_BCSS_PERSON_SERVICE",
  CONSULT_RN_SSIN_HISTORY = "CONSULT_RN_SSIN_HISTORY",
  HELENA_VISIT_INVITATION = "HELENA_VISIT_INVITATION",
}

export class PatientSync implements PatientSyncType {
  id: number;
  lastSyncState: Date;
  syncState: SyncState;
  syncServiceType: SyncServiceType;

  constructor(data?: PatientSyncType) {
    this.id = -1;
    this.syncState = SyncState.NEW;
    this.lastSyncState = new Date();
    this.syncServiceType = SyncServiceType.DEFAULT;
    data && Object.assign(this, data);
  }
}
